import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import Image from 'common/src/components/Image';
import Container from 'common/src/components/UI/Container';

import MoreBlogPostsSectionWrapper from './moreBlogPosts.style';
import Documentation from 'common/src/assets/image/saasModern/blog-header.png';
import { useTranslation } from 'react-i18next';

const MoreBlogPostsSection = ({
  row,
  col,
  title,
  description,
  button,
  textArea,
  imageArea,
  pageContext,
}) => {
  const { t } = useTranslation();
  return (
    <MoreBlogPostsSectionWrapper>
      <Container>
        <Box {...row}>
          <Box {...col} {...imageArea}>
            <Image src={Documentation} alt={t('Psono Documentation')} />
          </Box>
          <Box {...col} {...textArea}>
            <Heading {...title} content={t('Looking for more?')} />
            <Text
              {...description}
              content={t('Check out our latest articles here!')}
            />
            <Box>
              <Link to={`${pageContext.langPathPrefix}/blog`}>
                <Button {...button} title={t('VISIT OUR BLOG')} />
              </Link>
            </Box>
          </Box>
        </Box>
      </Container>
    </MoreBlogPostsSectionWrapper>
  );
};

MoreBlogPostsSection.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  button: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object,
};

MoreBlogPostsSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  imageAreaRow: {
    flexDirection: 'row-reverse',
  },
  col: {
    pr: '15px',
    pl: '15px',
  },
  textArea: {
    width: ['100%', '100%', '55%', '50%', '42%'],
  },
  imageArea: {
    width: ['100%', '100%', '45%', '50%', '58%'],
    mb: ['40px', '40px', '0', '0', '0'],
  },
  title: {
    fontSize: ['26px', '30px', '30px', '48px', '48px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '15px',
    lineHeight: '1.25',
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '33px',
  },
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'secondaryWithBg',
    minWidth: '150px',
  },
};

export default MoreBlogPostsSection;
